import { __api } from '../config';

export const BASE_URL = __api();

export const INDEX_WITH_PROFILE_ID = (
  params,
  resourceName,
  profileId = ""
) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/${resourceName}/getAll/${profileId}`,
  params
});

export const INDEX = (params, resourceName) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/getAll/${resourceName}`,
  params
});

export const INDEX_WITH_EXTRA = (params, resourceName) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/${resourceName}`,
  params
});

export const SHOW = (params, resourceName) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/${resourceName}/getone/${params.id}`,
  params: { ...params, id: null }
});

export const SHOW_WITH_EXTRA = (params, resourceName) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/${resourceName}/${params.id}`
});

export const SHOW_WITH_PROFILE_ID = (params, resourceName, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/${resourceName}/getone/${params.id}/${profileId}`
});

export const TAXONOMY_INDEX = taxonomyType => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/taxonomy/getValues/${taxonomyType}`
});

export const SORTED_TAXONOMY_INDEX = taxonomyType => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/taxonomy/getSortedValues/${taxonomyType}`
});

export const GET_PROFILE_ID = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/${params.userTypeUrl}/${params.userId}`
});

export const CREATE = (data, resourceName) => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/${resourceName}`,
  data
});

export const CREATE_WITH_PROFILE_ID = (data, resourceName, profileId) => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/${resourceName}/${profileId}`,
  data
});

export const UNFAVOURITE = params => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/fav/unfavourite/${params.favBy}/${params.favTo}`
});

export const ATHLETE_CLUB_INDEX = (params, profileId = "") => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/athlete/getAll/${profileId}`,
  params
});

export const ATHLETE_INDEX = (params, profileId = "") => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/athlete/forclgcoach/coachplayersearch/${profileId}`,
  params
});

export const ATHLETE_PROFILE_VIEWS_GET = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/views/${profileId}`,
  params
});

// Athlete Events
export const ATHLETE_EVENT_INDEX = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getall/playerEvents/${profileId}`,
  params
});

export const CREATE_ATHLETE_EVENT = (data, profileId) => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/events/addPlayerEvent/${profileId}`,
  data
});

export const UPDATE_ATHLETE_EVENT = (data, id) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/events/updatePlayerEvent/${id}`,
  data
});

export const DELETE_ATHLETE_EVENT = id => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/events/deletePlayerEvent/${id}`
});

export const ATHLETE_EVENT_IMAGE = (data, id) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/events/upload-update/playerEvent/image/${id}`,
  data
});

// College Events
export const COLLEGE_EVENT_INDEX = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getall/collegevents/${profileId}`,
  params
});

export const CREATE_COLLEGE_EVENT = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/events/addCollegeEvent`,
  data
});

export const UPDATE_COLLEGE_EVENT = (data, id) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/events/updateCollegeEvent/${id}`,
  data
});

export const DELETE_COLLEGE_EVENT = (data, id) => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/events/deleteCollegeEvent/${id}`,
  data
});

export const COLLEGE_EVENT_IMAGE = (data, id) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/events/upload-update/collegeevent/image/${id}`,
  data
});

// Club Events
export const CLUB_EVENT_INDEX = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getall/clubevents/${profileId}`,
  params
});

export const CREATE_CLUB_EVENT = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/events/addClubEvent`,
  data
});

export const UPDATE_CLUB_EVENT = (data, id) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/events/updateClubEvent/${id}`,
  data
});

export const DELETE_CLUB_EVENT = params => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/events/deleteClubEvent/${params.id}`,
  data: { ...params, id: null }
});

export const CLUB_EVENT_IMAGE = (data, id) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/events/upload-update/clubevent/image/${id}`,
  data
});

export const FAVOURITE_EVENT_INDEX = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/fav/${params.profileId}/${params.slug}/${params.playerProfileId}`
});

export const COLLEGE_INDEX = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/college/getAll/${profileId}`,
  params: { ...params, profileId: null }
});

export const COACH_INDEX = (params, profileId, resourceType) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/${resourceType || "coach"}/getAll/${profileId}`,
  params
});

export const CLUB_COACH_INDEX = (params, profileId, resourceType) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/${resourceType || "coach"}/getAll/${profileId}`,
  params
});

export const ROSTER_INDEX = (isActive, clubId, profileId, params) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/roster/getall/${clubId}/${isActive}/${profileId}`,
  params
});

export const UPDATE_COACH_INDEX = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/coach/updateOne/${data.id}`,
  data
});

export const TOGGLE_COACH_ACTIVATION = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/coach/de-activate/re-activate/account`,
  data
});

export const UPDATE_COACH_ROLE = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/coach/updateRole/${data.id}`,
  data
});

export const DELETE_COACH = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/coach/deleteOne`,
  data
});

export const DELETE_CLUB_COACH = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/clubCoach/coachingstaff/${data.coachId}`,
  data
});

export const CREATE_COACH = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/coach/createCoachByHeadCoach`,
  data
});

export const CREATE_CLUB_COACH = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/clubCoach/coachingstaff`,
  data
});

export const SHOW_CLUB_COACH = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/clubCoach/coachingstaff/${params.id}/${profileId}`,
  params
});

export const UPDATE_CLUB_COACH = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/clubCoach/coachingstaff/${data.id}`,
  data
});
export const DELETE = (resourceName, data) => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/${resourceName}/${data.id}`,
  data
});

export const EDIT = (resourceName, id, data) => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/${resourceName}/${id}`,
  data
});

export const INDEX_WITH_PROFILE_ID_CLUB_EVENTS = (
  params,
  resourceName,
  profileId
) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/${resourceName}/${profileId}`,
  params
});

export const CLUB_TEAM_HIGHLIGHT_INDEX = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/clubTeamHighlight/forclub/${params.id}/${profileId}`,
  params: { ...params, id: null }
});

export const COLLEGE_TEAM_HIGHLIGHT_INDEX = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/collegeTeamHighlight/forCollege/${params.id}/${profileId}`,
  params: { ...params, id: null }
});

export const CLUB_TEAM_HIGHLIGHT_SHOW = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/clubTeamHighlight/getone/${params.id}/${profileId}`,
  params
});

export const COLLEGE_TEAM_HIGHLIGHT_SHOW = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/collegeTeamHighlight/getone/${params.id}/${profileId}`,
  params
});

export const CLUB_TEAM_HIGHLIGHT_UPDATE = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/clubTeamHighlight/${data.id}`,
  data
});

export const CLUB_TEAM_HIGHLIGHT_CREATE = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/clubTeamHighlight`,
  data
});

export const CLUB_TEAM_HIGHLIGHT_DELETE = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/clubTeamHighlight/${data.id}`,
  data
});

export const COLLEGE_TEAM_HIGHLIGHT_UPDATE = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/collegeTeamHighlight/${data.id}`,
  data
});

export const COLLEGE_TEAM_HIGHLIGHT_CREATE = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/collegeTeamHighlight`,
  data
});

export const COLLEGE_TEAM_HIGHLIGHT_DELETE = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/collegeTeamHighlight/${data.id}`,
  data
});

export const COLLEGE_TEAM_HIGHLIGHT_IMAGE = (data, id) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/collegeTeamHighlight/upload-update/${id}`,
  data
});

export const CLUB_TEAM_HIGHLIGHT_IMAGE = (data, id) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/clubTeamHighlight/upload-update/${id}`,
  data
});

export const UPLOAD_IMAGE = (resourceName, id, image) => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/${resourceName}/image/${id}`,
  data: image
});

export const COACH_UPLOAD_IMAGE = (id, image) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/coach/upload-update/profileimage/${id}`,
  data: image
});

export const UPLOAD_IMAGE_POST = (resourceName, id, image) => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/${resourceName}/image/${id}`,
  data: image
});

export const COLLEGE_VIDEOS_INDEX = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/college/collegevideo/${params.id}`,
  params: { ...params, id: null }
});

export const CLUB_VIDEOS_INDEX = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/club/clubvideo/${params.id}`,
  params: { ...params, id: null }
});

export const COLLEGE_UPDATE_URL = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/college/${data.id}`,
  data
});

export const CLUB_UPDATE_URL = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/club/${data.id}`,
  data
});

export const UPLOAD_IMAGE_LOGO = (resourceName, id, image) => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/${resourceName}/image/logo/${id}`,
  data: image
});

export const DELETE_VIDEO_URL = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/college/collegevideo/update/${data.id}`,
  data
});

export const SAVE_COLLEGE_VIDEO_URL = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/college/collegevideo`,
  data
});

export const UPDATE_COLLEGE_VIDEO_URL = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/college/collegevideo/update/${data.id}`,
  data
});

export const DELETE_CLUB_VIDEO_URL = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/club/clubvideo/${data.id}`,
  data
});

export const SAVE_CLUB_VIDEO_URL = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/club/clubvideo`,
  data
});

export const UPDATE_CLUB_VIDEO_URL = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/club/clubvideo/${data.id}`,
  data
});

export const GET_CHAT_CONTACT_LIST = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/systemchat/contactlist/${profileId}`,
  params
});

export const GET_CHAT_MESSAGES = params => ({
  method: "GET",
  url: `${BASE_URL}/systemchat/message`,
  params
});

export const CONNECT_SOCKET = params => ({
  method: "GET",
  url: `${BASE_URL}/systemchat/chat`,
  params
});

export const BLOCK_CONTACT = (senderId, receiverId) => ({
  method: "PUT",
  url: `${BASE_URL}/systemchat/block/${senderId}/${receiverId}`
});

export const UNBLOCK_CONTACT = (senderId, receiverId) => ({
  method: "PATCH",
  url: `${BASE_URL}/systemchat/block/${senderId}/${receiverId}`
});

export const IGNORE_CONTACT = data => ({
  method: "PUT",
  url: `${BASE_URL}/systemchat/ignoredList`,
  data
});

export const SAVE_CONTACT = data => ({
  method: "PUT",
  url: `${BASE_URL}/systemchat/save`,
  data
});

export const DELETE_MULTIPLE_CONVERSATION = data => ({
  method: "PUT",
  url: `${BASE_URL}/systemchat/delete/bulk`,
  data
});

export const ATHLETE_VIDEOS = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/additional/video/${params.athleteId}`,
  params: { ...params, profileId, athleteId: null }
});

export const ATHLETE_IMAGES = data => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/athlete/image/profile/${data.get("id")}`,
  data
});

export const UPLOAD_ATHLETE_IMAGES = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/athlete/image/${data.id}/uploadphotos`,
  data: data.images
});

export const ATHLETE_EVENTS = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getall/playerEvents/${params.athleteId}`,
  params: { ...params, profileId, athleteId: null }
});

export const UPDATE_ATHLETE = (data, id) => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/athlete/${id}`,
  data
});

export const UPDATE_ATHLETE_TEAM_PLAYED = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/additional/teamPlayed/${data.id}`,
  data
});

export const GET_MESSAGE_PAGE = (id, params) => ({
  method: "GET",
  url: `${BASE_URL}/systemchat/getpage/message/${id}`,
  params
});

export const DELETE_CONVERSATION = data => ({
  method: "POST",
  url: `${BASE_URL}/systemchat/delete`,
  data
});

export const GET_ABOUT_US = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/aboutus`
});

export const GET_FAQ = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/getbytype/${params.faqType}`,
  params
});

export const GET_CONTACT_US = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/contactus`
});

export const SEND_MAIL = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/extra/contactus/sendmail`,
  data
});

export const CREATE_ATHLETE = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/athlete`,
  data
});

export const GET_RESOURCE_BY_TYPE = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/${params.resourceName}/${params.type}`,
  params: { type: params.type }
});

export const CREATE_COMPLAIN = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/extra/complaint/${data.complainantProfileId}`,
  data
});

export const POST_COMPLAIN_PHOTO = (data, complainId) => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/extra/complaint/image/${complainId}`,
  data
});

export const CHECK_CLUB_NAME = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/club/check/clubName/${params.clubName}`,
  params
});

export const CREATE_CLUB = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/clubverify`,
  data
});

export const GET_PRICING = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-pricing`
});

export const GET_ATHLETE_PRICING = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-plan-bytype/${params.type}`,
  params
});

export const GET_PRICING_DETAIL = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-plan-bytype/${params.type}`
});

export const GET_PREMIUM_CLUB_HEAD_COACH_PRICING = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-plan-bytype/${params.type}`,
  params
});

export const CONTACT_COACH_BY_EMAIL = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/coach/send-mail`,
  data
});

export const NORMAL_PAYMENT = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/promo/normal`,
  data
});

export const PROMO_CODE_PAYMENT = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/promo/promodetail`,
  data
});

export const PROMO_CODE_CHECK = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/promo/check`,
  params
});

export const PAYMENT_HISTORY = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/payment-history/payment-record`,
  data
});

export const PAYMENT_HISTORIES = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/payment-history/payment-record`,
  params
});

export const PAYMENT_PLANS = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-plan`,
  params
});

export const PROMO_CODE_PAYMENT_VALIDATION = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/promo/finalamount/verification`,
  params
});

export const UPLOAD_COLLEGE_IMAGES = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/college/upload-multiple/images/${data.id}`,
  data: data.images
});

export const UPLOAD_CLUB_IMAGES = data => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/club/upload-multiple/image/${data.id}`,
  data: data.images
});

export const CHECK_FAVOURITE = (favBy, favTo) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/fav/checkfavourite/${favBy}/${favTo}`
});

export const DELETE_ATHLETE_IMAGES = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/athlete/image/delete/${data.id}`,
  data
});

export const DELETE_COACH_IMAGES = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/coach/image/delete/${data.id}`,
  data
});

export const DELETE_CLUB_IMAGES = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/club/image/delete/${data.id}`,
  data
});

export const DELETE_COLLEGE_COACH_IMAGES = data => ({
  method: "DELETE",
  url: `${BASE_URL}/api/v1/college/image/delete/${data.id}`,
  data
});

export const PAYMENT_PLANS_CLUBS = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-plan-bytype/premiumclubHeadCoach`
});

export const PAYMENT_PLANS_ATHLETE = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-plan-bytype/player`
});

export const GET_ALL_SLIDERS = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/getAll-slider?sort=order`
});

export const GET_HOME_TRACK_PROFILE = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-homeTrackProfile`
});

export const GET_HOME_GETTING_STARTED = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-homeGettingStarted`
});

export const GET_HOME_DETAIL_INFO = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-homeDetailInfo`
});

export const GET_HOME_SECTION_INFO = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-homeSectionInfo`
});

export const GET_NECS = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/homescreen/necs`
});

export const CLUB_EVENT_SHOW = (id, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getone/clubevents/${id}/${profileId}`
});

export const COLLEGE_EVENT_SHOW = (id, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getone/collegevents/${id}/${profileId}`
});

export const RESET_USER_PASSWORD = data => ({
  method: "POST",
  url: `${BASE_URL}/api/v1/users/forgotPassword`,
  data
});

export const CHECK_TOKEN_USER_PASSWORD = data => ({
  method: "Get",
  url: `${BASE_URL}/api/v1/users/checkResetToken/${data.token}`
});

export const ATHLETE_EVENT_SHOW = (athleteProfileId, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getone/playerevents/${athleteProfileId}/${profileId}`
});

export const GET_PRICING_PICTURES = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/get-pricing-byType/${params.type}`
});

export const CLUB_EVENT_INDEX_V2 = (clubId, profileId, params) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getbyclub/${clubId}/${profileId}`,
  params
});

export const COLLEGE_EVENT_INDEX_V2 = (collegeId, profileId, params) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/events/getbycollege/${collegeId}/${profileId}`,
  params
});

export const GET_ALL_COLLEGES = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/college/forverify/collegelist`,
  params
});

export const GET_ALL_CLUBS = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/club/forverify/clublist`,
  params
});

export const GET_ALL_NOTIFICATIONS = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/notification/grp`,
  params
});

export const RENEWAL_SYSTEM_NOTIFICATION = params => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/renewal/${params.profileId}`,
  params
});

export const READ_NOTIFICATION = params => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/notification/${params.id}`
});

export const READ_NOTIFICATION_UPGRADE = params => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/renewal/${params.id}`
});

export const SCOUTING_ATHLETE_IMAGES = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/athlete/image/multiple/${data.get("id")}`,
  data
});

export const GET_COLLEGE_COACH = (params, profileId) => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/coach/getone/${params.id}/${profileId}`
});

export const UPDATE_BLOCKED_GROUP = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/athlete/blockgroup/${data.id}`,
  data
});

export const CHANGE_USER_PASSWORD = data => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/users/updateMyPassword`,
  data
});

export const RESET_TOKEN_USER_PASSWORD = data => ({
  method: "PATCH",
  url: `${BASE_URL}/api/v1/users/resetPassword/${data.token}`,
  data
});

export const PAYMENT_FREE_PATH = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/promo/normal`,
  data
});

export const INITIALIZE_PAYMENT = data => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/promo/init-payment`,
  data
});

export const GET_PRIVACY_POLICY = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/privacyPolicy`
});

export const GET_TERMS_AND_CONDITIONS = () => ({
  method: "GET",
  url: `${BASE_URL}/api/v1/extra/termsPolicy`
});

export const ATHLETE_SHOW = (params, profileId) => ({
  method: "GET",
  url: profileId
    ? `${BASE_URL}/api/v1/athlete/getone/${params.id}/${profileId}`
    : `${BASE_URL}/api/v1/athlete/getone/${params.id}`,
  params
});


export const UPDATE_VIEW_COUNT_COLLEGE = (data, profileId) => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/college/updateCollegeViewCount/${data.id}/${profileId}`,
})

export const UPDATE_VIEW_COUNT_CLUB = (data, profileId) => ({
  method: "PUT",
  url: `${BASE_URL}/api/v1/club/updateClubViewCount/${data.id}/${profileId}`,
})